module.exports = "/images/vendor/flag-icon-css/flags/4x3/zm.svg?a9ff495dd331a2364facd4ad5d6891a3";